import React, {Component} from 'react';
import PropTypes from 'prop-types';

import _ from 'lodash';

import * as RequestedDateTimePeriodWidget from './widget/pcoPlus/RequestedDateTimePeriodWidget';
import * as DateWidget from './widget/DateWidget';
import * as HeadingWidget from './widget/HeadingWidget';
import * as IntegerInputWidget from './widget/IntegerInputWidget';
import * as MultipleChoiceWidget from './widget/MultipleChoiceWidget';
import * as SingleChoiceWidget from './widget/SingleChoiceWidget';
import * as TextAreaWidget from './widget/TextAreaWidget';
import * as TextInputWidget from './widget/TextInputWidget';
import * as TitleInputWidget from './widget/TitleInputWidget';
import * as SubtitleInputWidget from './widget/SubtitleInputWidget';
import * as AbstractInputWidget from './widget/AbstractInputWidget';
import * as TopicSelectWidget from './widget/TopicSelectWidget';
import * as ThemesSelectWidget from './widget/ThemesSelectWidget';
import * as PresentationLanguageSelectWidget from './widget/PresentationLanguageSelectWidget';
import * as LogoUploadWidget from './widget/LogoUploadWidget';
import * as TextWidget from './widget/TextWidget';
import * as UploadWidget from './widget/UploadWidget';
import * as SpeakerWidget from './widget/SpeakerWidget';
import * as OtherPersonsWidget from './widget/OtherPersonsWidget';
import * as PresentationCountWidget from './widget/pcoPlus/PresentationCountWidget'
import * as PresentationTypeWidget from './widget/pcoPlus/PresentationTypeWidget'
import * as OrganizerRegiNumberWidget from './widget/pcoPlus/OrganizerRegiNumberWidget'

// Bestimmte Widgets werden auf andere Componenten gemappt
// z.b. AbstractInputWidget
const WIDGET_MODULES_BY_TYPE = _.transform([
    AbstractInputWidget,
    TitleInputWidget,
    SubtitleInputWidget,
    DateWidget,
    HeadingWidget,
    IntegerInputWidget,
    MultipleChoiceWidget,
    SingleChoiceWidget,
    TextAreaWidget,
    TextInputWidget,
    TopicSelectWidget,
    ThemesSelectWidget,
    PresentationLanguageSelectWidget,
    LogoUploadWidget,
    TextWidget,
    UploadWidget,
    SpeakerWidget,
    OtherPersonsWidget,
    RequestedDateTimePeriodWidget,
    PresentationCountWidget,
    PresentationTypeWidget,
    OrganizerRegiNumberWidget
], (acc, m) => {
    acc[m.type()] = m;
});

class CallForPapersFormWidget extends Component {
    render() {
        const Widget = WIDGET_MODULES_BY_TYPE[this.props.widget.type].component();

        return (
            <Widget {...this.props}/>
        );
    }
}

CallForPapersFormWidget.propTypes = {
    widget: PropTypes.object,
    formikProps: PropTypes.object
};

export function initialValue(widget, urlParams) {
    return WIDGET_MODULES_BY_TYPE[widget.type].initialValue(widget, urlParams);
}

/**
 * Gibt den Wert von der Submission zurück, um das Formular zu initialisieren
 *
 * @param callForPapers
 * @param widget
 * @param submission
 * @returns {undefined|*}
 */
export function submissionValue(callForPapers, widget, submission) {
    const widgetDefinition = WIDGET_MODULES_BY_TYPE[widget.type]
    if(_.has(widgetDefinition, 'submissionValue')) {
        return widgetDefinition.submissionValue(callForPapers, widget, submission);
    }
    return undefined
}

/**
 * @param widget
 * @param allowPartialSubmissions
 * @returns {*}
 */
export function widgetSchema(widget, allowPartialSubmissions) {
    return WIDGET_MODULES_BY_TYPE[widget.type].schema(widget, allowPartialSubmissions);
}

export function baseSchema(widget) {
    const widgetDefinition = WIDGET_MODULES_BY_TYPE[widget.type];
    if(_.has(widgetDefinition, 'baseSchema')) {
        return widgetDefinition.baseSchema(widget);
    }
    return undefined;
}

export default CallForPapersFormWidget;
